
import { defineComponent } from 'vue';
import { AppCard, AppTable, AppButton } from '@/components';
import { usePromotionBoosterDetail } from '@/modules/promotion/booster/model/detail';
import { PromotionBoosterLinkableType } from '@/modules/promotion/booster/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { Options as BoosterOptions } from '@/modules/booster/model/mixins';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.BOOSTER.DETAIL,
    components: { AppCard, AppTable, AppButton },
    setup() {
        const { model } = usePromotionBoosterDetail();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: BoosterOptions.ItemType },
                { type: TableColumnType.RouterLink, label: 'Name', key: 'name', to: row => row.link },
                { type: TableColumnType.Text, label: 'Quantity', key: 'quantity' }
            ]
        };

        return { model, table, ROUTE_NAME_PROMOTION, PromotionBoosterLinkableType };
    }
});
